import React, { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/Buyer/aboutus/about.css';

const AboutMission = ({ 
  title = "Explore your real estate",
  italicText = "dream into reality.",
  subtitle = "Sharing home since 1993.",
  description = "At Real Nest, we're redefining how people find homes by blending smart technology with human expertise. Our mission is to make real estate simple, transparent, and personalized for every client.",
  mission = "Our mission is to simplify property ownership through trust, transparency, expertise, care, commitment, and innovation.",
  vision = "Our vision is to redefine real estate experiences through innovation, excellence, accessibility, trust, technology, and lasting value.",
  videoSrc
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch((err) => {
        console.log("Autoplay blocked:", err);
      });
    }
  }, []);

  return (
    <section className="section-padding mission-section">
      <Container>
        {/* Mission Header */}
        <div className="mission-header mb-5">
          <h2 className="section-title text-start display-5 fw-bold mb-4 animate-on-scroll">
            {title} <span className="fst-italic">{italicText}</span>
            <br />
            {subtitle}
          </h2>
          <p className="section-subtitle text-muted mb-5 animate-on-scroll delay-1">
            {description}
          </p>
          
          <Row className="g-5">
            <Col md={6} className="animate-on-scroll delay-2">
              <h4 className="fw-bold mb-3 mission-heading">Mission</h4>
              <p className="text-muted mission-text">{mission}</p>
            </Col>
            <Col md={6} className="animate-on-scroll delay-2">
              <h4 className="fw-bold mb-3 vision-heading">Vision</h4>
              <p className="text-muted vision-text">{vision}</p>
            </Col>
          </Row>
        </div>

        {/* Video/Image Wrapper */}
        <div className="mission-image-wrapper animate-on-scroll">
          {videoSrc ? (
            <video
              ref={videoRef}
              src={videoSrc}
              autoPlay
              loop
              muted
              playsInline
              className="mission-video"
            />
          ) : (
            <img 
              src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80" 
              alt="Modern House" 
              className="mission-image" 
            />
          )}
        </div>
      </Container>
    </section>
  );
};

export default AboutMission;